import { endsWith } from 'ramda';

import companyDetailTemplate from './detail.tpl.html';
import { getCompanyById } from '../../../reducers/companies';

export class CompanyDetail {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
    const unsubscribe = $ngRedux.connect(CompanyDetail.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }
  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      company: getCompanyById(state, state.router.currentParams.id),
      router: state.router,
    };
  }

  $onInit() {
    if (!this.company) {
      this.reqCompanyDetails(this.router.currentParams.id);
    }

    if (endsWith('company.detail', this.router.currentState.name)) {
      this.state('authenticated.company.detail.documents', { id: this.router.currentParams.id });
    }
  }

  isRoute(match) {
    return this.router.currentState.name === match ||
      endsWith(match, this.router.currentState.name);
  }
}

CompanyDetail.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const companyDetail = {
  template: companyDetailTemplate,
  controller: CompanyDetail,
};
